import { useState, useMemo } from 'react'
import { Box, Button, Grid, Typography, Chip } from '@mui/material'
import { MdCalendarToday, MdAccessTime } from 'react-icons/md'
import { DisponibilidadeMock } from './mockData'
import { styles } from './styles'
import Header from './Header'

const formatarData = (dataStr) => {
  const [ano, mes, dia] = dataStr.split('-')
  return `${dia}/${mes}/${ano}`
}

const TelaDataHora = ({ onVoltar, onAvancar }) => {
  const [dataSelecionada, setDataSelecionada] = useState(null)
  const [horarioSelecionado, setHorarioSelecionado] = useState(null)

  const datasDisponiveis = useMemo(() => {
    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)
    return Object.entries(DisponibilidadeMock)
      .filter(
        ([data, horarios]) => horarios.length > 0 && new Date(data) >= hoje,
      )
      .map(([data]) => data)
  }, [])

  const horariosDisponiveis = useMemo(() => {
    if (!dataSelecionada) return []
    return DisponibilidadeMock[dataSelecionada] || []
  }, [dataSelecionada])

  const handleAvancar = () => {
    if (dataSelecionada && horarioSelecionado) {
      onAvancar({ data: dataSelecionada, horario: horarioSelecionado })
    }
  }

  return (
    <>
      <Header voltar={onVoltar} />
      <Box sx={{ flex: 1, overflow: 'auto', py: 3, px: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{ color: '#59a68d', fontWeight: 600, mb: 2 }}
            >
              Escolha uma Data
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {datasDisponiveis.map((data) => (
                <Button
                  key={data}
                  variant={dataSelecionada === data ? 'contained' : 'outlined'}
                  startIcon={<MdCalendarToday />}
                  onClick={() => {
                    setDataSelecionada(data)
                    setHorarioSelecionado(null)
                  }}
                  sx={{
                    borderColor: '#59a68d',
                    color: dataSelecionada === data ? 'white' : '#59a68d',
                    backgroundColor:
                      dataSelecionada === data ? '#59a68d' : 'transparent',
                    '&:hover': {
                      backgroundColor:
                        dataSelecionada === data ? '#528b79' : '#e8f5e9',
                    },
                  }}
                >
                  {formatarData(data)}
                </Button>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            {dataSelecionada && (
              <>
                <Typography
                  variant="subtitle1"
                  sx={{ color: '#59a68d', fontWeight: 600, mb: 1 }}
                >
                  Horários disponíveis para {formatarData(dataSelecionada)}
                </Typography>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {horariosDisponiveis.map((horario) => (
                    <Chip
                      key={horario}
                      icon={<MdAccessTime />}
                      label={horario}
                      variant={
                        horarioSelecionado === horario ? 'filled' : 'outlined'
                      }
                      onClick={() => setHorarioSelecionado(horario)}
                      sx={{
                        ...styles.horarioChip,
                        backgroundColor:
                          horarioSelecionado === horario
                            ? '#59a68d'
                            : 'transparent',
                        color:
                          horarioSelecionado === horario ? 'white' : '#59a68d',
                        '&:hover': {
                          backgroundColor:
                            horarioSelecionado === horario
                              ? '#528b79'
                              : '#e8f5e9',
                        },
                      }}
                    />
                  ))}
                </Box>
              </>
            )}
          </Grid>
        </Grid>

        {dataSelecionada && horarioSelecionado && (
          <Button
            variant="contained"
            sx={{ ...styles.primaryButton, mt: 3 }}
            fullWidth
            onClick={handleAvancar}
          >
            Confirmar Horário
          </Button>
        )}
      </Box>
    </>
  )
}

export default TelaDataHora
